import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Box,
    Chip,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Checkbox,
    FormControlLabel,
} from "@mui/material";

function AddPermissionModal({ open, onClose, roleId, currentPermissions, onAdded }) {
    const [allPermissions, setAllPermissions] = useState([]);
    const [filteredPermissions, setFilteredPermissions] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    // Reset selection when modal is opened
    useEffect(() => {
        if (open) {
            setSelectedPermissions([]);
            setSearchQuery("");
        }
    }, [open]);

    useEffect(() => {
        axios
            .get("/permissions")
            .then((res) => {
                const available = res.data.filter(
                    (p) => !currentPermissions.some((cp) => cp.id === p.id)
                );
                setAllPermissions(available);
                setFilteredPermissions(available);
            })
            .catch((err) => console.error("Error fetching permissions", err));
    }, [currentPermissions]);

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
        setFilteredPermissions(
            allPermissions.filter((p) =>
                p.perm_name.toLowerCase().includes(query)
            )
        );
    };

    const handleToggle = (permissionId) => {
        if (selectedPermissions.includes(permissionId)) {
            setSelectedPermissions(selectedPermissions.filter((id) => id !== permissionId));
        } else {
            setSelectedPermissions([...selectedPermissions, permissionId]);
        }
    };

    const handleRemoveSelected = (permissionId) => {
        setSelectedPermissions(selectedPermissions.filter((id) => id !== permissionId));
    };

    const handleSubmit = () => {
        console.log(selectedPermissions, "PERM", roleId, "ROLE");

        axios
            .post(`/rolePermission`, { roleId, permissions: selectedPermissions })
            .then(() => {
                onAdded();
                onClose();
            })
            .catch((err) => console.error("Error adding permissions", err));
    };

    const availablePermissions = filteredPermissions.filter(
        (p) => !selectedPermissions.includes(p.id)
    );

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Add Permissions</DialogTitle>
            <DialogContent>
                {/* Summary of selected permissions */}
                {selectedPermissions.length > 0 && (
                    <Box sx={{ mb: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {allPermissions
                            .filter((perm) => selectedPermissions.includes(perm.id))
                            .map((perm) => (
                                <Chip
                                    key={perm.id}
                                    label={perm.perm_name}
                                    onDelete={() => handleRemoveSelected(perm.id)}
                                    color="primary"
                                />
                            ))}
                    </Box>
                )}

                {/* Search Field */}
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Search permissions..."
                    value={searchQuery}
                    onChange={handleSearch}
                    margin="normal"
                />

                {/* List of available permissions (excluding selected ones) */}
                {availablePermissions.map((permission) => (
                    <FormControlLabel
                        key={permission.id}
                        control={
                            <Checkbox
                                checked={selectedPermissions.includes(permission.id)}
                                onChange={() => handleToggle(permission.id)}
                            />
                        }
                        label={permission.perm_name}
                    />
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    disabled={selectedPermissions.length === 0}
                >
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AddPermissionModal;